
export default class FormAccordion {
    constructor(parent){
        this.parent = parent;
        this.router = parent.router;
        this.accordionSections = parent.el.querySelectorAll('.form_accordion');
        this.accordionHeaders = [...this.accordionSections].map((item) => item.querySelector('.accordion_title'));
        this.form = parent.form;
        this.bind();
    }

    bind() {
        this.accordionHeaders.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
    
                const parent = e.target.closest('.form_accordion');
                const title = parent.querySelector('.accordion_title');
                const contentSection = parent.querySelector('.accordion_content');
    
                if(!parent.classList.contains('disabled')) {
                    title.classList.toggle('open');
                    contentSection.classList.toggle('hide');
                }
            });
        }); 
    }
}